import React, { forwardRef } from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const Svg = forwardRef<SVGSVGElement, Props>((props, ref) => {
  return <svg ref={ref} {...props} />;
});

export default Svg;
